import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { Table, Select, Col, Row, Pagination, Input, Modal, InputNumber, /*Popconfirm,*/ Form, Tooltip, Button, Checkbox } from 'antd';
import { Link } from 'react-router-dom'
// import columnIcon from '../../../assets/images/icons/column.svg'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../TableLoader";
import errorData from '../../../assets/images/data-graph/error-data.svg';
import { notifyfailure, notifysuccess, notifycatch } from "../../../utils/toast";
import addIcon from '../../../assets/images/icons/add.svg';
import CTVConfigureAdcodes from "./CTVConfigureAdcodes";
import { saveAs } from "file-saver";
import { jwtDecode } from "jwt-decode";
// import mediaKitIcon from '../../../assets/images/icons/export_download_icon.svg';
import deleteIcon from '../../../assets/images/icons/trash.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import csvIcon from '../../../assets/images/icons/csv.svg';
import txtIcon from '../../../assets/images/icons/txt.svg';
import uploadIcon from '../../../assets/images/icons/upload-cloud.svg';
import downloadCsvIcon from '../../../assets/images/icons/download_csv_icon.svg';
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";
import uploadFileIcon from '../../../assets/images/icons/upload_file_icon.svg';
import historyButton from '../../../assets/images/icons/history_button.svg';
// import uploadCsvCtvIcon from '../../../assets/images/icons/upload_csv_ctv.svg';
import ctvAmazonStoreIcon from '../../../assets/images/icons/ctv_amazon_store.svg';
import ctvAndroidStoreIcon from '../../../assets/images/icons/ctv_android_store.svg';
import ctvAppleStoreIcon from '../../../assets/images/icons/ctv_apple_store.svg';
import ctvLgStoreIcon from '../../../assets/images/icons/ctv_lg_store.svg';
import ctvVizioStoreIcon from '../../../assets/images/icons/ctv_vizio_store.svg';
import ctvSamsungStoreIcon from '../../../assets/images/icons/ctv_samsung_store.svg';
import ctvRokuStoreIcon from '../../../assets/images/icons/ctv_roku_store.svg';
import removeIcon from '../../../assets/images/icons/minus_circle_remove_ icon.svg';
import { SearchOutlined } from '@ant-design/icons';
// import filterIcon from '../../../assets/images/icons/filter.svg';
import HoverCloseIcon from '../../../assets/images/icons/hover_close.svg';
import Papa from 'papaparse';
import ctvXboxStoreIcon from '../../../assets/images/icons/ctv_xbox_store.svg';
import ctvChromecastStoreIcon from '../../../assets/images/icons/ctv_chromecast_store.svg';
import ctvFireStoreIcon from '../../../assets/images/icons/ctv_fire_store.svg';
import ctvHisenseStoreIcon from '../../../assets/images/icons/ctv_hisense_store.svg';
import ctvRogersStoreIcon from '../../../assets/images/icons/ctv_rogers_store.svg';
import ctvPanasonicStoreIcon from '../../../assets/images/icons/ctv_panasonic_store.svg';
import ctvKindleStoreIcon from '../../../assets/images/icons/ctv_kindle_store.svg';
import ctvOdkStoreIcon from '../../../assets/images/icons/ctv_odk_store.svg';
import ctvXumoStoreIcon from '../../../assets/images/icons/ctv_xumo_store.svg';
import ctvMagnavoxStoreIcon from '../../../assets/images/icons/ctv_magnavox_store.svg';
import ctvMicrosoftStoreIcon from '../../../assets/images/icons/ctv_microsoft_store.svg';
import ctvPhillipsStoreIcon from '../../../assets/images/icons/ctv_phillips_store.svg';
import ctvSonyStoreIcon from '../../../assets/images/icons/ctv_sony_store.svg';
import ctvSanyoStoreIcon from '../../../assets/images/icons/ctv_sanyo_store.svg';
import ctvShawStoreIcon from '../../../assets/images/icons/ctv_shaw_store.svg';
import ctvTitanStoreIcon from '../../../assets/images/icons/ctv_titan_store.svg';
import ctvX1StoreIcon from '../../../assets/images/icons/ctv_x1_store.svg';

const { Option } = Select;

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    inputType,
    editingCell,
    setEditingCell,
    ...restProps
}) => {
    const inputRef = useRef(null);
    const form = useContext(EditableContext);


    const isEditing = editingCell && record && editingCell.key === record.key && editingCell.dataIndex === dataIndex;

    useEffect(() => {
        if (isEditing) {
            inputRef.current?.focus();
        }
    }, [isEditing]);

    const toggleEdit = () => {
        setEditingCell({ key: record.key, dataIndex });
        form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    };

    const cancelEdit = () => {
        form.setFieldsValue({ [dataIndex]: record[dataIndex] });
        setEditingCell(null);
    };

    const save = async () => {
        try {
            const values = await form.validateFields();

            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = isEditing ? (
            <div className="d_flex form_content_block--group  test" style={{ paddingRight: "0.5rem", gap: "0.35rem", paddingLeft: "0.3rem" }}>
                <Form.Item
                    style={{ margin: 0, width: "100%" }}

                    name={dataIndex}
                    rules={[
                        { required: true, message: `Value is required.` },
                        {
                            validator: (_, value) => {

                                if (dataIndex === "ads_txt" &&
                                    !value.trim().startsWith("http://") &&
                                    !value.trim().startsWith("https://") &&
                                    // !value.trim().startsWith("www.") &&
                                    value.trim() !== "") {
                                    return Promise.reject(new Error('Value must start with http:// or https:// '));
                                }

                                // if (!value || value.trim() === '') {
                                //     return Promise.reject(new Error('Input cannot be empty or whitespace.'));
                                // }
                                // if (value.length > 10) {
                                //     return Promise.reject(new Error('Input must be 10 characters or less.'));
                                // }
                                // if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                                //     return Promise.reject(new Error('No special characters allowed.'));
                                // }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    {inputType === 'number' ? (
                        <InputNumber ref={inputRef} className="form_control basic " style={{ paddingRight: "0.6rem" }} autoComplete="off" />
                    ) : (
                        <Input ref={inputRef} className="form_control basic" style={{ paddingRight: "0.6rem" }} autoComplete="off" />
                    )}
                </Form.Item>

                {record.isLoading ?
                    <button
                        className="btn btn_primary mt-0  w_fit_content loader"
                        style={{ width: "3.2rem", height: "3.2rem", margin: "0rem", padding: "0.3rem", borderRadius: "0.6rem" }}
                    >
                        <span>Submit</span>

                        <img
                            src={loaderIcon}
                            alt="USP"
                            className="loader_icon"
                        />
                    </button>
                    :
                    <Tooltip title="Submit">
                        <div className="editable_cell_ctv" onClick={save}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z" fill="#1E293B" />
                                <path d="M21.3337 12L14.0003 19.3333L10.667 16" stroke="white" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                    </Tooltip>
                }

                {record.isLoading ?
                    <div className="editable_cell_ctv" >
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z" fill="#F04438" />
                            <path d="M20 12L12 20" stroke="white" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 12L20 20" stroke="white" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </div>
                    :
                    <Tooltip title="Discard">
                        <div className="editable_cell_ctv" onClick={cancelEdit}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z" fill="#F04438" />
                                <path d="M20 12L12 20" stroke="white" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 12L20 20" stroke="white" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                    </Tooltip>
                }

            </div>
        ) : (
            <div className="wrapping_ads_txt" >
                <div className="editable-cell-value-wrap" onClick={toggleEdit}  >
                    {children}
                </div>
                <div className="ads_txt_image">
                    {(record.ads_txt !== "" && record.ads_txt !== undefined && record.ads_txt !== null) &&
                        <a href={record.ads_txt} target="_blank" rel="noreferrer" className="ads_txt_link">
                            <svg
                                xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path className="stroke" d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path className="stroke" d="M10 2H14V6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path className="stroke" d="M6.66699 9.33333L14.0003 2" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>


                    }
                </div>
            </div>
        );
    }

    return <td  {...restProps}>{childNode}</td>;
};




const CTVMediaPlanner = () => {

    const [editingCell, setEditingCell] = useState(null);

    // const handleSave = (row) => {
    //     const newData = [...data];
    //     const index = newData.findIndex(item => row.key === item.key);
    //     const item = newData[index];
    //     newData.splice(index, 1, { ...item, ...row });
    //     setData(newData);
    // };
    const handleSave = async (row) => {

        // console.log(row)
        // return

        const newData = [...data];
        const newDataBackup = [...data];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        const updatedRow = { ...item, ...row, isLoading: true };

        // Update the state
        newData.splice(index, 1, updatedRow);
        setData(newData);

        // 🔥 Send API call here
        try {
            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");

                axios
                    .put(configData.SERVER_URL + `ctv/updateCTV`, {
                        key: updatedRow.key,
                        ads_txt: updatedRow.ads_txt,
                    }, {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                    .then((response) => {
                        const freshData = [...newData];
                        freshData.splice(index, 1, response.data.data);
                        setData(freshData);
                        setEditingCell(null);
                        if (response.data.message && response.data.message !== "No changes detected; update not required.") {
                            notifysuccess(response.data.message)
                        }

                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error.response.data.message?.length !== 0) {
                                notifyfailure(error.response.data.message)
                            }
                        } else {
                            notifycatch()
                        }

                        setData(newDataBackup);
                        setEditingCell(null);

                    });
            }



        } catch (error) {
            notifyfailure('API error while saving row:', error)
        }
    };

    const loadingContext = useContext(LoadingContext);

    const [filterDropdowns, setFilterDropdowns] = useState([])
    const getColumnDefinitions = () => [
        {
            title: 'Bundle',
            dataIndex: 'bundle',
            key: "bundle",
            editable: false,
            inputType: 'text',
            width: 150,
            fixed: "left",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 28 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data.slice(0, 28)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' >{data}</div>

                        }
                    </>
                )

            },
        },
        {
            title: 'Store',
            dataIndex: 'store',
            key: "store",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            // fixed: "left",
            editable: false,
            inputType: 'text',
            width: 130,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {

                let actualData = data

                if (data !== "" && data !== undefined && data !== null && data !== "-") {
                    data = data?.toLowerCase()
                }

                return (
                    <div className="d-flex gap_8" >

                        <img src={"amazon".includes(data) ? ctvAmazonStoreIcon : "android".includes(data) ? ctvAndroidStoreIcon : "apple".includes(data) ? ctvAppleStoreIcon : "lg".includes(data) ? ctvLgStoreIcon : "vizio".includes(data) ? ctvVizioStoreIcon : "roku".includes(data) ? ctvRokuStoreIcon : "samsung".includes(data) ? ctvSamsungStoreIcon : "sony".includes(data) ? ctvSonyStoreIcon : "phillips".includes(data) ? ctvPhillipsStoreIcon : "titan".includes(data) ? ctvTitanStoreIcon : "odk".includes(data) ? ctvOdkStoreIcon : "kindle".includes(data) ? ctvKindleStoreIcon : "xbox".includes(data) ? ctvXboxStoreIcon : "fire".includes(data) ? ctvFireStoreIcon : "hisense".includes(data) ? ctvHisenseStoreIcon : "rogers".includes(data) ? ctvRogersStoreIcon : "shaw".includes(data) ? ctvShawStoreIcon : "xumo".includes(data) ? ctvXumoStoreIcon : "magnavox".includes(data) ? ctvMagnavoxStoreIcon : "panasonic".includes(data) ? ctvPanasonicStoreIcon : "sanyo".includes(data) ? ctvSanyoStoreIcon : "x1".includes(data) ? ctvX1StoreIcon : "chromecast".includes(data) ? ctvChromecastStoreIcon : "microsoft".includes(data) ? ctvMicrosoftStoreIcon : ""} alt="icon" style={{ height: "1.6rem", width: "1.6rem" }}
                            className="store-icon"
                        />


                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 15 ?
                                <Tooltip title={actualData}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{actualData.slice(0, 15)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' >{actualData}</div>

                        }

                    </div>
                )

            },

        },

        {
            title: 'App Url',
            dataIndex: 'app_url',
            key: "app_url",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            editable: false,
            inputType: 'text',
            // width: 250,
            width: 200,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            // data.length >= 28 ?
                            data.length >= 35 ?
                                <Tooltip title={data}><a href={data.includes("https://") ? data : "https://" + data} style={{ color: "#00349B" }} target="_blank" rel="noreferrer" className='text_ellipsis text_primary' >{data.slice(0, 35)}...</a></Tooltip>
                                :
                                <a href={data.includes("https://") ? data : "https://" + data} style={{ color: "#00349B" }} target="_blank" rel="noreferrer" className='text_ellipsis text_primary' >{data}</a>

                        }
                    </div>
                )

            },
        },

        {
            title: 'Ads.txt',
            dataIndex: 'ads_txt',
            key: "ads_txt",
            editable: true,
            inputType: 'text',
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            minWidth: 200,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark' style={{ minWidth: "20rem" }}>-</div></> :
                            data.length >= 36 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data.slice(0, 36)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' >{data}</div>

                        }
                    </>
                )

            },
        },
        {
            title: 'Adcodes',
            dataIndex: 'adcode',
            key: "adcode",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            editable: false,
            inputType: 'text',
            width: 150,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 36 ?
                                <Tooltip
                                    overlayInnerStyle={{
                                        width: "500px",
                                        maxHeight: "150px",
                                        height: "auto",
                                        overflowY: 'auto', // Enable scrolling for overflow content
                                        overflowX: 'hidden',
                                    }}
                                    title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data.slice(0, 36)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' >{data}</div>

                        }
                    </>
                )

            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            editable: false,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            inputType: 'text',
            width: 150,
            // width: 180,
            // width: 160,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 28 ?
                                // data.length >= 24 ?
                                // data.length >= 17 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data.slice(0, 28)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' >{data}</div>

                        }
                    </>
                )

            },
            // width: 200,
            // render: (data, record) => {
            //     data = "dshaskd dashdasjkd sdef"
            //     return (
            //         <>
            //             {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
            //                 data.length >= 24 ?
            //                     <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip>
            //                     :
            //                     <div className='text_ellipsis d-block' >{data}</div>

            //             }
            //         </>
            //     )

            // },
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            editable: false,
            inputType: 'text',
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            width: 130,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Processed At',
            dataIndex: 'processed',
            key: 'processed',
            editable: false,
            inputType: 'text',
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            width: 130,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Updated At',
            dataIndex: 'updated',
            key: 'updated',
            editable: false,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            inputType: 'text',
            width: 130,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Manipulated At (UTC)',
            dataIndex: 'm_update',
            key: 'm_update',
            editable: false,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            inputType: 'text',
            width: 180,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            // data.length >= 24 ?
                            data.length >= 24 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data.slice(0, 24)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' >{data}</div>

                        }
                    </>
                )

            },
        },
        {
            title: 'Error',
            dataIndex: 'err',
            key: 'err',
            editable: false,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            inputType: 'text',
            width: 70,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {

                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Error Message',
            dataIndex: 'err_msg',
            key: 'err_msg',
            editable: false,
            inputType: 'text',
            width: 170,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 24 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data.slice(0, 24)}...</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
    ]
    const [columns, setColumns] = useState(getColumnDefinitions());

    const processColumns = (columns) => {
        const filterVisibleColumns = (cols) => {
            return cols.reduce((acc, col) => {
                if (col.children) {
                    const visibleChildren = filterVisibleColumns(col.children);
                    if (visibleChildren.length > 0) {
                        acc.push({ ...col, children: visibleChildren });
                    }
                } else if (!col.hidden) {
                    acc.push(col);
                }
                return acc;
            }, []);
        };

        const applyCellLogic = (cols) => {
            return cols.map(col => {
                if (col.children) {
                    return {
                        ...col,
                        children: applyCellLogic(col.children),
                    };
                }

                if (!col.editable) {
                    return {
                        ...col,
                        onCell: () => ({
                            className: col.cellClassName || '',
                        }),
                    };
                }

                return {
                    ...col,
                    onCell: record => ({
                        className: col.cellClassName || '',
                        record,
                        editable: col.editable,
                        dataIndex: col.dataIndex,
                        title: col.title,
                        inputType: col.inputType,
                        handleSave,
                        editingCell,
                        setEditingCell,
                    }),
                };
            });
        };

        const visibleColumns = filterVisibleColumns(columns);
        return applyCellLogic(visibleColumns);
    };

    // Usage
    const mergedColumns = processColumns(columns);

    // const mergedColumns = columns.map(col => {
    //     if (!col.editable) return {
    //         ...col,
    //         onCell: () => ({
    //             className: col.cellClassName || '',
    //         }),
    //     };
    //     return {
    //         ...col,
    //         onCell: record => ({
    //             className: col.cellClassName || '',
    //             record,
    //             editable: col.editable,
    //             dataIndex: col.dataIndex,
    //             title: col.title,
    //             inputType: col.inputType,
    //             handleSave,
    //             editingCell,
    //             setEditingCell,
    //         }),
    //     };
    // });


    const [data, setData] = useState([]);
    const [adcodeCount, setaAdcodeCount] = useState(0);


    const [apiCall, setApicall] = useState(false)
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [firstTimeLoad, setFirstTimeLoad] = useState(true)
    const [pageView, setPageView] = useState("table")

    const [page, setPage] = useState({
        current: 1,
        pageSize: 100,
        total: 0,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const [colvisLength] = useState(9)
    const [colvis, setColvis] = useState({
        "store": true,
        "name": true,
        "app_url": true,
        "ads_txt": true,
        "adcode": true,
        "createdAt": true,
        "processed": true,
        "updated": true,
        "m_update": true,
        "err": true,
        "err_msg": true,
    })

    const [filterRepeaterValueOptions_colvis] = useState([
        { label: "Store", value: "store" },
        { label: "Name", value: "name" },
        { label: "App Url", value: "app_url" },
        { label: "Ads.txt", value: "ads_txt" },
        { label: "Adcodes", value: "adcode" },
        { label: "Created At", value: "createdAt" },
        { label: "Processed At", value: "processed" },
        { label: "Updated At", value: "updated" },
        { label: "Manipulated At", value: "m_update" },
        { label: "Error", value: "err" },
        { label: "Error Message", value: "err_msg" },

    ])
    const [filterRepeaterValueOptions_Adcodes_colvis, setFilterRepeaterValueOptions_Adcodes_colvis] = useState([])
    const [filterRepeaterValueOptions_Od_colvis, setFilterRepeaterValueOptions_Od_colvis] = useState([])
    const [filterRepeaterValueOptions_Ipd_colvis, setFilterRepeaterValueOptions_Ipd_colvis] = useState([])

    const isIndeterminate = (colvis) => {
        const values = Object.values(colvis);
        return values.some(value => value) && !values.every(value => value);
    };
    const isIndeterminateAdcodes = (colvis) => {
        const relevantKeys = filterRepeaterValueOptions_Adcodes_colvis.map(item => item.value);
        const values = relevantKeys.map(key => colvis[key]);
        return values.some(value => value) && !values.every(value => value);
    };
    const isIndeterminateOd = (colvis) => {
        const relevantKeys = filterRepeaterValueOptions_Od_colvis.map(item => item.value);
        const values = relevantKeys.map(key => colvis[key]);
        return values.some(value => value) && !values.every(value => value);
    };
    const isIndeterminateIpd = (colvis) => {
        const relevantKeys = filterRepeaterValueOptions_Ipd_colvis.map(item => item.value);
        const values = relevantKeys.map(key => colvis[key]);
        return values.some(value => value) && !values.every(value => value);
    };
    const trueKeyCountIpd = (colvis) => {
        const relevantKeys = filterRepeaterValueOptions_Ipd_colvis.map(item => item.value);
        const values = relevantKeys.map(key => colvis[key]);
        return values.filter(value => value === true).length;
    };

    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            let tempArr = { ...filterApplyApiCall }
            tempArr.filterArray = filterApplyApiCall.filterArray.map(({ valueSearch, options, validation_value, ...rest }) => rest);

            axios
                .post(configData.SERVER_URL + `ctv/mediaPlanner?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, { filter: tempArr }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {

                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }

                    setaAdcodeCount(response.data.data.count)
                    setLoading(false)
                    setInitialLoad(false)
                    setFirstTimeLoad(false)
                })
                .catch((error) => {
                    setaAdcodeCount(0)
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                    setFirstTimeLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()

        axios
            .get(configData.SERVER_URL + "ctv/headers", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setFilterDropdowns(response.data.data);
            })
            .catch((error) => { });
        getData()
        loadingContext.done()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingContext]);


    useEffect(() => {

        if (Object.keys(filterDropdowns).length > 0) {

            if ('ctv_adcodes' in filterDropdowns) {
                setFilterRepeaterValueOptions_Adcodes_colvis(filterDropdowns.ctv_adcodes)
            }
            if ('ctv_od' in filterDropdowns) {
                setFilterRepeaterValueOptions_Od_colvis(filterDropdowns.ctv_od)
            }
            if ('ctv_ipd' in filterDropdowns) {
                setFilterRepeaterValueOptions_Ipd_colvis(filterDropdowns.ctv_ipd)
            }

            const tempColumns = [...columns];
            const tempColvis = { ...colvis };

            const getWidth = (label) => {
                const length = label?.length || 0;
                if (length > 40) return 300;
                if (length > 35) return 280;
                if (length > 30) return 250;
                if (length > 25) return 220;
                if (length > 22) return 195;
                if (length > 19) return 185;
                if (length > 16) return 175;
                if (length > 13) return 155;
                if (length > 10) return 130;
                return 108;
            };

            let ctv_adcodesArray = []
            let ctv_odArray = []
            let ctv_ipdArray = []

            if ('ctv_adcodes' in filterDropdowns) {
                const adcodes = filterDropdowns.ctv_adcodes;

                adcodes.forEach((item, index) => {
                    ctv_adcodesArray.push({
                        title: item.label.length > 35
                            ? <Tooltip title={item.label}>{item.label.slice(0, 35)}...</Tooltip>
                            : item.label,
                        dataIndex: item.value,
                        // className: "col_group_subheader1",
                        className: "",
                        key: item.value,
                        onHeaderCell: () => ({
                            className: 'border_right_0',
                        }),
                        editable: false,
                        inputType: 'text',
                        width: adcodes.length === 1 ? getWidth(item.label) > 140 ? getWidth(item.label) : 140 : getWidth(item.label),
                        render: (data, record) => {
                            return (
                                <div className={index === 0 ? "first_cell_group group_cell_ctv" : "rest_cell_group group_cell_ctv"}>
                                    {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                                        <>
                                            {data}
                                        </>
                                    }
                                </div>
                            )
                        }
                    });

                    if (!(item.value in tempColvis)) {
                        tempColvis[item.value] = true;
                    }
                });

            }

            if ('ctv_od' in filterDropdowns) {
                const ctv_od = filterDropdowns.ctv_od;

                ctv_od.forEach((item, index) => {
                    ctv_odArray.push({
                        title: item.label.length > 35
                            ? <Tooltip title={item.label}>{item.label.slice(0, 35)}...</Tooltip>
                            : item.label,
                        dataIndex: item.value,
                        className: "col_group_subheader2",
                        key: item.value,
                        editable: false,
                        onHeaderCell: () => ({
                            className: 'border_right_0',
                        }),
                        inputType: 'text',
                        width: ctv_od.length === 1 ? getWidth(item.label) > 140 ? getWidth(item.label) : 140 : getWidth(item.label),
                        render: (data, record) => {
                            return (
                                <div className={index === 0 ? "first_cell_group group_cell_ctv" : "rest_cell_group group_cell_ctv"}>
                                    {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                                        <>
                                            {data}
                                        </>
                                    }
                                </div>
                            )
                        }
                    });

                    if (!(item.value in tempColvis)) {
                        tempColvis[item.value] = true;
                    }
                });

            }

            if ('ctv_ipd' in filterDropdowns) {
                const ctv_ipd = filterDropdowns.ctv_ipd;

                ctv_ipd.forEach((item, index) => {
                    ctv_ipdArray.push({
                        title: item.label.length > 35
                            ? <Tooltip title={item.label}>{item.label.slice(0, 35)}...</Tooltip>
                            : item.label,
                        dataIndex: item.value,
                        className: "col_group_subheader3",
                        key: item.value,
                        editable: false,
                        onHeaderCell: () => ({
                            className: 'border_right_0',
                        }),
                        inputType: 'text',
                        width: ctv_ipd.length === 1 ? getWidth(item.label) > 180 ? getWidth(item.label) : 180 : getWidth(item.label),
                        render: (data, record) => {
                            return (
                                <div className={index === 0 ? "first_cell_group group_cell_ctv" : "rest_cell_group group_cell_ctv"}>
                                    {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                                        <>
                                            {data}
                                        </>
                                    }
                                </div>
                            )
                        }
                    });

                    if (!(item.value in tempColvis)) {
                        tempColvis[item.value] = true;
                    }
                });

            }

            if (ctv_adcodesArray.length > 0) {
                tempColumns.push({
                    title: "Adcodes", className: "",
                    onHeaderCell: () => ({
                        className: 'diff_border_line_clr',
                    }), children: ctv_adcodesArray
                })
            }

            if (ctv_odArray.length > 0) {
                tempColumns.push({
                    title: "Owner Domain", className: "", onHeaderCell: () => ({
                        className: 'diff_border_line_clr',
                    }), children: ctv_odArray
                })
            }

            if (ctv_ipdArray.length > 0) {
                tempColumns.push({
                    title: "Inventory Partner Domain", className: "", onHeaderCell: () => ({
                        className: 'diff_border_line_clr',
                    }), children: ctv_ipdArray
                })
            }

            setColumns(tempColumns);
            setColvis(tempColvis);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterDropdowns])

    // useEffect(() => {

    //     let tempLength = Object.keys(colvis).length;
    //     if (tempLength !== colvisLength) {

    //         setColumns(columns.map((column) =>
    //             column.key in colvis // Check if the key exists in colvis
    //                 ? { ...column, hidden: !colvis[column.key] } // Update hidden if the key exists
    //                 : column // Leave unchanged if the key doesn't exist
    //         ))
    //     }

    // }, [colvis])

    useEffect(() => {
        let tempLength = Object.keys(colvis).length;

        if (tempLength !== colvisLength) {
            const updateColumns = (cols) => {
                return cols.map((column) => {
                    if (column.children && column.children.length > 0) {
                        // It's a parent column; don't set 'hidden' on the parent
                        return {
                            ...column,
                            children: updateColumns(column.children), // Recursively update children
                        };
                    } else {
                        // Leaf column; set hidden based on colvis
                        return column.key in colvis
                            ? { ...column, hidden: !colvis[column.key] }
                            : column;
                    }
                });
            };

            setColumns(updateColumns(columns));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colvis]);



    useEffect(() => {
        if (!firstTimeLoad) {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    //--------------------------------------------------------Export Media Planner -------------------------------------------------------------//

    const [exportMediaPlannerLoading, setExportMediaPlannerLoading] = useState(false)

    function filterMergedArray(arr1, arr2, arr3, arr4, obj) {
        // Merge the arrays while keeping unique 'value' keys
        const mergedMap = new Map();

        [...arr1, ...arr2, ...arr3, ...arr4].forEach(item => mergedMap.set(item.value, item.label));

        // Filter only those objects where obj[value] is true
        return Array.from(mergedMap)
            .filter(([value]) => obj[value]) // Keep only values that are true in obj
            .map(([value, label]) => ({ label, value }));
    }

    const exportMediaPlanner = () => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            let tempArr = { ...filterApplyApiCall }
            tempArr.filterArray = filterApplyApiCall.filterArray.map(({ valueSearch, options, validation_value, ...rest }) => rest);

            const tempColvisExport = filterMergedArray(filterRepeaterValueOptions_colvis, filterRepeaterValueOptions_Adcodes_colvis, filterRepeaterValueOptions_Od_colvis, filterRepeaterValueOptions_Ipd_colvis, colvis)

            tempColvisExport.unshift({ label: "Bundle", value: "bundle" })

            setExportMediaPlannerLoading(true)
            axios
                .post(configData.SERVER_URL + "ctv/exportCSV", {
                    email: jwtDecode(token).email,
                    count: page.total,
                    search: search,
                    filter: tempArr,
                    columnFilter: tempColvisExport
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    if (response.data.message !== undefined) {
                        notifysuccess(response.data.message)
                    }
                    else {
                        const blob = new Blob([response.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        saveAs(blob, "CTV_" + new Date().getTime() + ".xlsx");
                        // notifysuccess("File downloaded successfully")
                    }

                    setExportMediaPlannerLoading(false)
                })
                .catch((error) => {
                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                        }
                    } else {
                        notifycatch()
                    }
                    setExportMediaPlannerLoading(false)
                });

        }
    };

    //--------------------------------------------------------Export Media Planner -------------------------------------------------------------//


    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };


    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setColumns(getColumnDefinitions())
            setData([])
            setInitialLoad(true)

            axios
                .get(configData.SERVER_URL + "ctv/headers", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setFilterDropdowns(response.data.data);

                    const validValues_ctv_adcodes = (response.data.data?.ctv_adcodes || [])
                        .filter(item => item.type === "ctv_adcodes")
                        .map(item => item.value);

                    const validValues_ctv_od = (response.data.data?.ctv_od || [])
                        .filter(item => item.type === "ctv_od")
                        .map(item => item.value);

                    const validValues_ctv_ipd = (response.data.data?.ctv_ipd || [])
                        .filter(item => item.type === "ctv_ipd")
                        .map(item => item.value);


                    let tempArr = { ...filterApplyApiCall }
                    tempArr.connector = filterRepeaterConnectorValue
                    tempArr.filterArray = filterRepeater.flatMap(obj => {
                        if (obj.label === "ctv_adcodes") {
                            const newValue = obj.value.filter(val => validValues_ctv_adcodes.includes(val));
                            return newValue.length > 0 ? [{ ...obj, value: newValue }] : [];
                        }
                        if (obj.label === "ctv_od") {
                            const newValue = obj.value.filter(val => validValues_ctv_od.includes(val));
                            return newValue.length > 0 ? [{ ...obj, value: newValue }] : [];
                        }
                        if (obj.label === "ctv_ipd") {
                            const newValue = obj.value.filter(val => validValues_ctv_ipd.includes(val));
                            return newValue.length > 0 ? [{ ...obj, value: newValue }] : [];
                        }
                        return [obj];
                    });

                    if (tempArr.filterArray.length === 0) {
                        tempArr.connector = "";
                    }
                    setFilterApplyApiCall(tempArr)

                    let tempPage = page
                    tempPage.current = 1
                    setPage(tempPage);
                    setApicall(!apiCall)

                    setFilterRepeater(prev =>
                        prev.flatMap(obj => {
                            if (obj.label === "ctv_adcodes") {
                                const newValue = obj.value.filter(val => validValues_ctv_adcodes.includes(val));
                                return newValue.length > 0 ? [{ ...obj, value: newValue }] : [];
                            }
                            if (obj.label === "ctv_od") {
                                const newValue = obj.value.filter(val => validValues_ctv_od.includes(val));
                                return newValue.length > 0 ? [{ ...obj, value: newValue }] : [];
                            }
                            if (obj.label === "ctv_ipd") {
                                const newValue = obj.value.filter(val => validValues_ctv_ipd.includes(val));
                                return newValue.length > 0 ? [{ ...obj, value: newValue }] : [];
                            }
                            return [obj];
                        })
                    );

                })
                .catch((error) => {
                    setApicall(!apiCall)
                });



        }

        setPageView(data)

    }

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };



    // Modal related code upload csv .............................................................................................................................
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const closeModal = () => {
        setIsModalVisible(false);
        resetModalData()
    };

    function resetModalData() {
        // setErrorMsgBackendData([])
        setCtvCsvUpload({
            data: "",
            filename: "",
            type: "",
            size: ""
        })
        setErrorMsg(null)
        setButtonProcessing(false)
    }


    const validHeaders = ["bundle", "store", "app_url", "name", "ads.txt"];
    const allowedStores = ["android", "roku", "amazon", "apple", "vizio", "lg", "samsung", "sony", "phillips", "titan", "odk", "kindle", "xbox", "fire", "hisense", "rogers", "shaw", "xumo", "magnavox", "panasonic", "sanyo", "x1", "chromecast", "microsoft"];

    const [ctvCsvUpload, setCtvCsvUpload] = useState({
        data: "",
        preview: "",
        filename: "",
        size: ""
    });
    const [errorMsg, setErrorMsg] = useState(null);
    // const [errorMsgBackendData, setErrorMsgBackendData] = useState([]);
    const [buttonProcessing, setButtonProcessing] = useState(false)

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // if (!file) return;

        if (file !== undefined) {
            if (file.size / (1024 * 1024) < 100 && (file.type === "text/csv" || file.type === "application/vnd.ms-excel")) {

                const reader = new FileReader();
                reader.onload = (event) => {
                    const csvText = event.target.result;

                    const parsed = Papa.parse(csvText, {
                        header: true,
                        skipEmptyLines: true
                    });

                    if (parsed.errors.length > 0) {
                        setErrorMsg(`Parsing error: ${parsed.errors[0].message}`);
                        return;
                    }

                    const rows = parsed.data;
                    const headers = parsed.meta.fields.map(h => h.trim().toLowerCase());

                    // Validate exact headers
                    const sortedHeaders = [...headers].sort();
                    const sortedValidHeaders = [...validHeaders].sort();
                    const isHeaderValid = JSON.stringify(sortedHeaders) === JSON.stringify(sortedValidHeaders);

                    if (!isHeaderValid) {
                        // const missing = validHeaders.filter(h => !headers.includes(h));
                        // const extra = headers.filter(h => !validHeaders.includes(h));

                        // let errMsg = "Invalid headers:";
                        // if (missing.length > 0) errMsg += ` missing - ${missing.join(", ")}`;
                        // if (extra.length > 0) errMsg += ` extra - ${extra.join(", ")}`;
                        // setErrorMsg(errMsg);
                        setErrorMsg("Invalid header data format")
                        return;
                    }

                    // const bundleIndex = headers.indexOf("bundle");
                    // const storeIndex = headers.indexOf("store");
                    const nameIndex = headers.indexOf("name");
                    const appUrlIndex = headers.indexOf("app_url");
                    const adsTxtIndex = headers.findIndex(h => h === "ads.txt");

                    // const seenPairs = new Set();

                    if (rows.length > 1000) {
                        setErrorMsg("Row limit exceeded. Maximum 1000 rows allowed (excluding header).");
                        return;
                    }

                    for (let i = 0; i < rows.length; i++) {
                        const row = rows[i];
                        const rowNumber = i + 2; // header is row 1

                        const bundle = row["bundle"];
                        const store = row["store"];
                        const name = row["name"];
                        const appUrl = row["app_url"];
                        const adsTxt = row["ads.txt"];

                        if (!bundle || !store) {
                            setErrorMsg(`Row ${rowNumber}: 'bundle' and 'store' are required.`);
                            return;
                        }

                        if (typeof bundle !== "string" || typeof store !== "string") {
                            setErrorMsg(`Row ${rowNumber}: 'bundle and store' must be strings.`);
                            return;
                        }

                        if (!allowedStores.includes(store.toLowerCase())) {
                            setErrorMsg(`Row ${rowNumber}: Invalid store value '${store}'.`);
                            return;
                        }

                        // const key = `${bundle.toLowerCase()}|${store.toLowerCase()}`;
                        // if (seenPairs.has(key)) {
                        //     setErrorMsg(`Row ${rowNumber}: Duplicate (bundle, store) pair found.`);
                        //     return;
                        // }
                        // seenPairs.add(key);

                        if (nameIndex !== -1 && name && typeof name !== "string") {
                            setErrorMsg(`Row ${rowNumber}: 'name' must be a string.`);
                            return;
                        }

                        if (appUrlIndex !== -1 && appUrl && typeof appUrl !== "string") {
                            setErrorMsg(`Row ${rowNumber}: 'app_url' must be a string.`);
                            return;
                        }

                        if (adsTxtIndex !== -1 && adsTxt) {
                            if (typeof adsTxt !== "string") {
                                setErrorMsg(`Row ${rowNumber}: 'ads.txt' must be a string.`);
                                return;
                            }

                            if (
                                !adsTxt.startsWith("http://") &&
                                !adsTxt.startsWith("https://")
                            ) {
                                setErrorMsg(`Row ${rowNumber}: Invalid ads.txt URL. Must start with http:// or https://`);
                                return;
                            }
                        }
                    }

                    setErrorMsg(null);
                    setCtvCsvUpload({
                        data: file,
                        preview: URL.createObjectURL(file),
                        filename: file.name,
                        size: file.size
                    });
                };

                reader.readAsText(file);
            }
            else {
                if (file.size / (1024 * 1024) >= 100) {
                    setErrorMsg('File must be less than 100 MB in size');
                } else {
                    setErrorMsg('Unsupported file format. Please upload a CSV file');
                }
            }

        }
        const fileInput00 = document.getElementById("file0029");
        if (fileInput00) {
            fileInput00.value = "";
        }
    };

    const handSubmitCtvCsvUpload = async (e) => {
        e.preventDefault();

        if (
            ctvCsvUpload?.filename !== ""
        ) {
            if (
                errorMsg === null
            ) {

                let formData = new FormData();
                formData.append('file', ctvCsvUpload.data);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonProcessing(true)
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `ctv/uploadcsv`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewEdit("table", "yes")
                            setIsModalVisible(false)
                            resetModalData()

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    // let message = error.response.data.message 
                                    // if (error.response.data.data !==undefined){
                                    //     message = message + JSON.stringify(error.response.data.data)

                                    // }
                                    // setErrorMsgBackendData(error.response.data.data)
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonProcessing(false)

                        });
                }
            }
        } else {
            if (ctvCsvUpload?.filename === "") {
                setErrorMsg("This field is required")
            }

        }
    };


    const handleDownload = async () => {

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL +
                    `ctv/download-sample`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "text/csv;charset=utf-8",
                    });
                    saveAs(blob, "sample.csv");
                })
                .catch((error) => { });
        }
    };


    //----------------------------------------------------------------------------------------------------------------//

    //--------------------------filter related code starts -----------------------------------------------------------//
    //---------------------------------------------------------------------------------------------------------------------------//

    const [filterRepeaterValueOptions_Store] = useState([
        { "label": "Amazon", "value": "amazon" },
        { "label": "Android", "value": "android" },
        { "label": "Apple", "value": "apple" },
        { "label": "LG", "value": "lg" },
        { "label": "Roku", "value": "roku" },
        { "label": "Samsung", "value": "samsung" },
        { "label": "Vizio", "value": "vizio" },
        { "label": "Sony", "value": "sony" },
        { "label": "Phillips", "value": "phillips" },
        { "label": "Titan", "value": "titan" },
        { "label": "ODK", "value": "odk" },
        { "label": "Kindle", "value": "kindle" },
        { "label": "Xbox", "value": "xbox" },
        { "label": "Fire", "value": "fire" },
        { "label": "Hisense", "value": "hisense" },
        { "label": "Rogers", "value": "rogers" },
        { "label": "Shaw", "value": "shaw" },
        { "label": "Xumo", "value": "xumo" },
        { "label": "Magnavox", "value": "magnavox" },
        { "label": "Panasonic", "value": "panasonic" },
        { "label": "Sanyo", "value": "sanyo" },
        { "label": "X1", "value": "x1" },
        { "label": "Chromecast", "value": "chromecast" },
        { "label": "Microsoft", "value": "microsoft" },
    ])

    const [filterRepeaterConnectorOptions] = useState([{ label: "and", value: "and" }, { label: "or", value: "or" }])
    const [filterRepeaterLabelOptions] = useState(
        [
            { "label": "Adcodes", "value": "ctv_adcodes" },
            { "label": "Owner Domain", "value": "ctv_od" },
            { "label": "IP Domain", "value": "ctv_ipd" },
            { "label": "Store", "value": "store" },
        ])

    const [filterShow, setFilterShow] = useState(false)
    const [filterRepeaterConnectorValue, setFilterRepeaterConnectorValue] = useState("and")
    const [filterRepeater, setFilterRepeater] = useState([]);
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({ connector: "", filterArray: [] });


    const dropdownRef = useRef(null);
    const filterShowRef = useRef(filterShow);
    useEffect(() => {
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
                &&
                filterShowRef
            ) {
                const allSelectElements = document.querySelectorAll('#adcodeSelect');
                const allDropdownsClosed = Array.from(allSelectElements).every((selectElement) => {
                    return !selectElement.closest('.ant-select')?.classList?.contains('ant-select-open');
                });

                if (allDropdownsClosed) {

                    setFilterRepeater(filterApplyApiCall?.filterArray)
                    setFilterRepeaterConnectorValue(filterApplyApiCall.connector === "" ? "and" : filterApplyApiCall.connector)
                    setFilterShow(false);
                }
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });


    const handleAddFilterRepeater = (data) => {
        setFilterRepeater([
            ...filterRepeater,
            {
                label: data,
                value: [],
                condition: "",
                other: "",
                valueSearch: "",
                options: [],
                validation_value: false,

            },
        ]);


    };

    const handleRemoveFeedListRepeater = (index) => {
        let tempFilter = [...filterRepeater];
        tempFilter.splice(index, 1);
        setFilterRepeater(tempFilter);

    };

    const handleChangeFilterLabel = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["label"] = event;
        tempFilter[index]["value"] = [];
        tempFilter[index]["condition"] = "";
        tempFilter[index]["other"] = "";
        tempFilter[index]["valueSearch"] = "";
        tempFilter[index]["options"] = [];
        tempFilter[index]["validation_value"] = false;
        setFilterRepeater(tempFilter);
    };

    const handleChangeValueSearch = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["valueSearch"] = event.target.value.trim();
        setFilterRepeater(tempFilter);
    };

    // const handleChangeFilterCondition = (event, index) => {
    //     const tempFilter = [...filterRepeater];
    //     tempFilter[index]["condition"] = event
    //     setFilterRepeater(tempFilter);
    // };

    // const handleChangeFilterOther = (event, index) => {
    //     const tempFilter = [...filterRepeater];
    //     tempFilter[index]["other"] = event
    //     tempFilter[index]["validation_value"] = false
    //     setFilterRepeater(tempFilter);
    // };

    const handleChangeFilterValue = (event, index, type) => {
        const tempFilter = [...filterRepeater];
        let newValue = [];
        if (tempFilter[index].value.includes(event)) {
            newValue = tempFilter[index].value.filter((item) => item !== event);
        } else {
            newValue = [...tempFilter[index].value, event];
        }

        if (newValue.length === 0) {
            tempFilter[index].validation_value = true
        }
        else {
            tempFilter[index].validation_value = false
        }
        tempFilter[index].value = newValue

        setFilterRepeater(tempFilter);
    };


    const validateFilterValue = () => {
        let allValuesValid = true;
        setFilterRepeater(prevFilterRepeater =>
            prevFilterRepeater.map(item => {
                let isValueEmpty;
                isValueEmpty = item.value.length === 0;
                if (isValueEmpty) {
                    allValuesValid = false;
                }
                return {
                    ...item,
                    validation_value: isValueEmpty,
                };
            })
        );
        return allValuesValid;
    };


    const handleApplyFilterRepeater = () => {

        if (validateFilterValue()) {
            let tempArr = { ...filterApplyApiCall }
            tempArr.connector = filterRepeaterConnectorValue
            tempArr.filterArray = filterRepeater
            setFilterApplyApiCall(tempArr)
            setFilterShow(false)
        }

    };

    const handleResetFilterRepeater = () => {
        setFilterApplyApiCall({
            connector: "",
            filterArray: [],
        })
        setFilterRepeater([])
        setFilterRepeaterConnectorValue("and")
        setFilterShow(false)

    };

    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterApplyApiCall])


    const scrollableDivRef = useRef(null);
    const [prevRepeaterCount, setPrevRepeaterCount] = useState(filterRepeater.length);

    const [openSelectState, setOpenSelectState] = useState({});


    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    // Handle scroll to close all Select dropdowns
    useEffect(() => {
        const handleScroll = () => {
            if (Object.values(openSelectState).some((isOpen) => isOpen)) {
                setOpenSelectState({}); // Close all open dropdowns
            }
        };

        const debouncedHandleScroll = debounce(handleScroll, 50); // Debounce for smoothness
        // const scrollableDiv = scrollableDivRef.current;

        const currentDiv = scrollableDivRef.current;
        if (currentDiv) {
            currentDiv.addEventListener('scroll', debouncedHandleScroll);
        }


        return () => {
            if (currentDiv) {
                currentDiv.removeEventListener('scroll', debouncedHandleScroll);
            }
        };

    }, [openSelectState]);


    useEffect(() => {
        if (filterRepeater.length > prevRepeaterCount) {
            // Scroll only when a new form is added
            if (scrollableDivRef.current) {
                scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
            }
            setPrevRepeaterCount(filterRepeater.length); // Update the count
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterRepeater]);

    // Function to toggle open state for a specific Select
    const toggleSelectOpen = (key, open) => {
        setOpenSelectState((prevState) => {
            if (prevState[key] === open) return prevState; // Avoid unnecessary updates
            return { ...prevState, [key]: open };
        });
    };


    const refs = {};
    function getRef(key) {
        if (!refs[key]) {
            refs[key] = React.createRef();
        }
        return refs[key];
    }

    useEffect(() => {
        Object.keys(openSelectState).forEach((key) => {
            if (openSelectState[key]) {
                const ref = refs[key];
                setTimeout(() => {
                    ref?.current?.focus();
                }, 0);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openSelectState]);


    return (
        <>
            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        CTV
                    </h1>

                    <div className="btn_group">
                        {!initialLoad &&
                            <>
                                <button className='btn btn_primary w_fit_content md'
                                    onClick={() => { setPageView("create") }}
                                ><span><img src={addIcon} alt='USP' /> Configure Adcodes</span></button>
                            </>}
                    </div>

                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>
                                {!initialLoad &&
                                    <>
                                        <div className="custom_filter_design_d2 justify-content-end --new_layout_design_btn">


                                            <div className="custom_media_filter_d2 --remove_overflow_css mediaPlanner_filter">

                                                <Dropdown className=""
                                                    ref={dropdownRef}
                                                    show={filterShow} onToggle={() => {

                                                        if (!filterShow) {
                                                            if (filterRepeater.length === 0) {
                                                                setFilterRepeater([
                                                                    ...filterRepeater,
                                                                    {
                                                                        label: "ctv_adcodes",
                                                                        value: [],
                                                                        condition: "",
                                                                        other: "",
                                                                        valueSearch: "",
                                                                        options: [],
                                                                        validation_value: false,

                                                                    },
                                                                ]);

                                                            }
                                                        }

                                                        setFilterShow(!filterShow)


                                                    }}
                                                    autoClose={false}>
                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                        <Dropdown.Toggle id="dropdown-autoclose-false px-2">
                                                            <Button className="" icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }>
                                                                Filter
                                                                {filterApplyApiCall?.filterArray?.length > 0 &&
                                                                    <div className="selected_filter_tag_d2">
                                                                        <div>{filterApplyApiCall?.filterArray?.length}</div>
                                                                    </div>
                                                                }
                                                            </Button>
                                                        </Dropdown.Toggle>
                                                        {filterApplyApiCall?.filterArray?.length > 0 &&
                                                            <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                                <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                    onClick={() => {
                                                                        setFilterApplyApiCall({
                                                                            connector: "",
                                                                            filterArray: [],
                                                                        })
                                                                        setFilterRepeater([])
                                                                        setFilterRepeaterConnectorValue("and")
                                                                        setFilterShow(false)
                                                                    }} />
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>

                                                    <Dropdown.Menu>
                                                        <div className="filter_inner_heading_d2 ">
                                                            <div className="filter_scrollable_div_d2" ref={scrollableDivRef}>
                                                                {filterRepeater.map((x, i) => {
                                                                    return (
                                                                        <Row gutter={8} className='formHtml align-items-start' key={i}>
                                                                            <Col className="or_and_select_d2">

                                                                                {i === 0 ?
                                                                                    <>
                                                                                        <span className="is_text">Where</span>
                                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">


                                                                                        </div>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                                            <Select
                                                                                                id="adcodeSelect"
                                                                                                showSearch={false}
                                                                                                placeholder=""
                                                                                                // open={true}
                                                                                                popupClassName="or_and_d2"
                                                                                                optionFilterProp="label"
                                                                                                className='form_select basic no_search'
                                                                                                options={filterRepeaterConnectorOptions}
                                                                                                open={!!openSelectState[`where-${i}`]}
                                                                                                onDropdownVisibleChange={(open) => toggleSelectOpen(`where-${i}`, open)}
                                                                                                value={filterRepeaterConnectorValue}
                                                                                                onChange={(event) => { setFilterRepeaterConnectorValue(event) }}
                                                                                            />

                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </Col>

                                                                            <Col span={6}>
                                                                                <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">

                                                                                    <Select
                                                                                        id="adcodeSelect"
                                                                                        showSearch={true}
                                                                                        placeholder=""
                                                                                        optionFilterProp="label"
                                                                                        className='form_select basic'
                                                                                        open={!!openSelectState[`property-${i}`]}
                                                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`property-${i}`, open)}
                                                                                        options={filterRepeaterLabelOptions}
                                                                                        value={x.label}
                                                                                        onChange={(event) => {
                                                                                            handleChangeFilterLabel(event, i)

                                                                                        }}
                                                                                    />

                                                                                </div>
                                                                            </Col>



                                                                            <Col className="flex-grow-1 checkbox_value_select_d2 multi_select_tag_d2">
                                                                                <div className="form_content_block--group mb_0">
                                                                                    <div className='d-flex '>
                                                                                        <div className="w-100">



                                                                                            {(x.label === "ctv_adcodes" || x.label === "ctv_od" || x.label === "ctv_ipd" || x.label === "store"
                                                                                            ) &&
                                                                                                <Select
                                                                                                    id="adcodeSelect"
                                                                                                    value={x.value}
                                                                                                    popupClassName='diff_select_d2 --filter_half'
                                                                                                    // open={true}
                                                                                                    showSearch={false}
                                                                                                    placeholder='- Select -'
                                                                                                    className={x.validation_value ? 'form_select basic error' : 'form_select basic'}
                                                                                                    mode='multiple'
                                                                                                    open={!!openSelectState[`propertyone-${i}`]}
                                                                                                    onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyone-${i}`, open)}
                                                                                                    maxTagCount='responsive'
                                                                                                    dropdownRender={menu => (
                                                                                                        <>
                                                                                                            <div className="custom_inside_searchbar_d2">
                                                                                                                <Input placeholder="Search"
                                                                                                                    value={x.valueSearch}
                                                                                                                    onChange={(event) => {
                                                                                                                        handleChangeValueSearch(event, i)
                                                                                                                    }}
                                                                                                                    ref={getRef(`propertyone-${i}`)}
                                                                                                                    prefix={<SearchOutlined className="search_icon_d2" />}
                                                                                                                // allowClear 
                                                                                                                />
                                                                                                            </div>

                                                                                                            {menu}
                                                                                                        </>
                                                                                                    )}
                                                                                                >

                                                                                                    {
                                                                                                        (x.label === "ctv_adcodes" ?
                                                                                                            [
                                                                                                                ...filterRepeaterValueOptions_Adcodes_colvis?.filter(option => x.value?.includes(option.value)),
                                                                                                                ...filterRepeaterValueOptions_Adcodes_colvis?.filter(option => !x.value?.includes(option.value))
                                                                                                            ]
                                                                                                            :
                                                                                                            x.label === "ctv_od" ?
                                                                                                                [
                                                                                                                    ...filterRepeaterValueOptions_Od_colvis?.filter(option => x.value?.includes(option.value)),
                                                                                                                    ...filterRepeaterValueOptions_Od_colvis?.filter(option => !x.value?.includes(option.value))
                                                                                                                ]
                                                                                                                :
                                                                                                                x.label === "ctv_ipd" ?
                                                                                                                    [
                                                                                                                        ...filterRepeaterValueOptions_Ipd_colvis?.filter(option => x.value?.includes(option.value)),
                                                                                                                        ...filterRepeaterValueOptions_Ipd_colvis?.filter(option => !x.value?.includes(option.value))
                                                                                                                    ]

                                                                                                                    :
                                                                                                                    x.label === "store" ?
                                                                                                                        [
                                                                                                                            ...filterRepeaterValueOptions_Store?.filter(option => x.value?.includes(option.value)),
                                                                                                                            ...filterRepeaterValueOptions_Store?.filter(option => !x.value?.includes(option.value))
                                                                                                                        ] :
                                                                                                                        []
                                                                                                        )?.filter((option) =>
                                                                                                            option.label.toLowerCase().includes(x.valueSearch?.toLowerCase() || '')
                                                                                                        )
                                                                                                            .map(option => (
                                                                                                                <Option key={option.value} value={option.value}>
                                                                                                                    <div
                                                                                                                        onClick={() => handleChangeFilterValue(option.value, i, "")}
                                                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                                                    >
                                                                                                                        <Checkbox
                                                                                                                            checked={x.value?.includes(option.value)}
                                                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                                                        >
                                                                                                                            {option.label}
                                                                                                                        </Checkbox>
                                                                                                                    </div>
                                                                                                                </Option>
                                                                                                            ))}
                                                                                                </Select>
                                                                                            }


                                                                                        </div>
                                                                                        <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                            <img className='delete_form_icon' src={removeIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                        </div>

                                                                                    </div>

                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                })}
                                                            </div>

                                                            <div className="adjust_padding_d2">
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <div className='addnewform_d2 addnewform_filter_d2 scroll_option_div'>
                                                                            <Dropdown className="inner_dropdown_btn_d2">
                                                                                <Dropdown.Toggle className="dropdown-autoclose-false px-2" id="dropdown-basic">
                                                                                    <img src={addIcon} className="m-0" alt='Add Property' /> Add Property
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("ctv_adcodes") }}>Adcodes</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("ctv_od") }}>Owner Domain</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("ctv_ipd") }}>IP Domain</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("store") }}>Store</Dropdown.Item>
                                                                                </Dropdown.Menu>


                                                                            </Dropdown>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {filterRepeater.some(obj => obj.validation_value === true) && <span className="error_content">  Please fill all required fields </span>}
                                                                <hr />
                                                            </div>
                                                        </div>

                                                        { }

                                                        <div className="adjust_padding_d2">
                                                            <div className="filter_bottom_btns_d2 text-end">
                                                                <button className="reset" type='button' onClick={handleResetFilterRepeater}
                                                                >Reset</button>
                                                                <button className="apply" type='button' onClick={handleApplyFilterRepeater}
                                                                >Apply</button>
                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>


                                            <Button className={isModalVisible ? 'button_upload_csv_ctv active' : 'button_upload_csv_ctv'} onClick={showModal}
                                                icon={
                                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9.99707 11.5007L7.99707 9.50073L5.99707 11.5007" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7.99707 9.50073V13.5007" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M12.5783 12.5C13.1102 12.189 13.5305 11.6969 13.7727 11.1013C14.0148 10.5057 14.0652 9.84065 13.9157 9.21099C13.7663 8.58133 13.4256 8.02298 12.9474 7.62404C12.4691 7.22511 11.8806 7.00832 11.2748 7.0079H10.5876C10.4225 6.32313 10.1148 5.68741 9.68762 5.14853C9.26046 4.60965 8.72493 4.18163 8.12131 3.89664C7.51768 3.61166 6.86167 3.47713 6.20258 3.50317C5.5435 3.52921 4.89849 3.71515 4.31606 4.04699C3.73363 4.37884 3.22893 4.84796 2.8399 5.41909C2.45087 5.99022 2.18763 6.6485 2.06998 7.34444C1.95233 8.04037 1.98333 8.75585 2.16065 9.43709C2.33796 10.1183 2.65698 10.7476 3.09372 11.2776" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M9.99707 11.5007L7.99707 9.50073L5.99707 11.5007" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                }>
                                                {/* <img src={uploadCsvCtvIcon} alt='USP' /> */}
                                                <span>CSV Upload</span>
                                            </Button>


                                            <div className="column_hide_unhide_d3 column_hide_unhide_mediaplanner_d2">
                                                <Dropdown className="" autoClose="outside">
                                                    <Dropdown.Toggle id="dropdown-autoclose-outside">
                                                        <Button className="" icon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                <path d="M1.5 3H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.5 3H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M1.5 7H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.5 7H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M1.5 11H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.5 11H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }>
                                                            Columns
                                                        </Button>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <div className="colunm_checkbox">
                                                            <ul className="p-0 m-0"

                                                            >
                                                                <li
                                                                >
                                                                    <label htmlFor="select_all_adcodes">
                                                                        <input
                                                                            className={isIndeterminate(colvis) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                            type="checkbox"
                                                                            id="select_all_adcodes"
                                                                            checked={Object.values(colvis).every(value => value === true)}
                                                                            onChange={(e) => {
                                                                                const updatedObj = Object.keys(colvis).reduce((acc, key) => {
                                                                                    acc[key] = e.target.checked;
                                                                                    return acc;
                                                                                }, {});

                                                                                setColvis(updatedObj);
                                                                            }}
                                                                        />
                                                                        <span>
                                                                            < >Select All</>
                                                                        </span>
                                                                    </label>
                                                                </li>
                                                                <hr className="new_item_line_d3" />

                                                            </ul>

                                                            <ul
                                                                className="p-0 m-0 colvis_scroll"
                                                            >
                                                                <Row >

                                                                    {filterRepeaterValueOptions_colvis.map(({ label, value }) => (
                                                                        <Col span={8}>
                                                                            <li key={value}>
                                                                                <label htmlFor={value}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={value}
                                                                                        checked={colvis[value]}
                                                                                        onChange={() => {
                                                                                            const tempData = { ...colvis };
                                                                                            tempData[value] = !tempData[value];
                                                                                            setColvis(tempData);
                                                                                        }}
                                                                                    />
                                                                                    <span> {label?.length >= 50 ?
                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                        < >{label}</>}
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                        </Col>
                                                                    ))}

                                                                    {filterRepeaterValueOptions_Adcodes_colvis.length > 0 &&
                                                                        <>
                                                                            <hr className="new_item_line_d3" />
                                                                            <Col span={24}>

                                                                                <li>
                                                                                    <label htmlFor="select_all_adcodes1">
                                                                                        <input
                                                                                            className={isIndeterminateAdcodes(colvis) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                                            type="checkbox"
                                                                                            id="select_all_adcodes1"
                                                                                            checked={
                                                                                                filterRepeaterValueOptions_Adcodes_colvis
                                                                                                    .map(item => item.value)
                                                                                                    .every(key => colvis[key] === true)
                                                                                            }
                                                                                            onChange={(e) => {
                                                                                                // console.log("hit")

                                                                                                const impactedKeys = filterRepeaterValueOptions_Adcodes_colvis.map(item => item.value);
                                                                                                const updatedObj = Object.keys(colvis).reduce((acc, key) => {
                                                                                                    acc[key] = impactedKeys.includes(key) ? e.target.checked : colvis[key];
                                                                                                    return acc;
                                                                                                }, {});

                                                                                                setColvis(updatedObj);
                                                                                            }}
                                                                                        />
                                                                                        <span>
                                                                                            < >Select All Adcodes</>
                                                                                        </span>
                                                                                    </label>
                                                                                </li>
                                                                            </Col>
                                                                        </>
                                                                    }


                                                                    {filterRepeaterValueOptions_Adcodes_colvis.map(({ label, value }) => (
                                                                        <Col span={8}>
                                                                            <li key={value}>
                                                                                <label htmlFor={value}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={value}
                                                                                        checked={colvis[value]}
                                                                                        onChange={() => {
                                                                                            const tempData = { ...colvis };
                                                                                            tempData[value] = !tempData[value];
                                                                                            setColvis(tempData);
                                                                                        }}
                                                                                    />
                                                                                    <span> {label?.length >= 50 ?
                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                        < >{label}</>}
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                        </Col>
                                                                    ))}
                                                                    {filterRepeaterValueOptions_Od_colvis.length > 0 &&
                                                                        <>

                                                                            <hr className="new_item_line_d3" />

                                                                            <Col span={24}>

                                                                                <li >
                                                                                    <label htmlFor="select_all_adcodes2">
                                                                                        <input
                                                                                            className={isIndeterminateOd(colvis) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                                            type="checkbox"
                                                                                            id="select_all_adcodes2"
                                                                                            checked={
                                                                                                filterRepeaterValueOptions_Od_colvis
                                                                                                    .map(item => item.value)
                                                                                                    .every(key => colvis[key] === true)
                                                                                            }
                                                                                            onChange={(e) => {
                                                                                                const impactedKeys = filterRepeaterValueOptions_Od_colvis.map(item => item.value);
                                                                                                const updatedObj = Object.keys(colvis).reduce((acc, key) => {
                                                                                                    acc[key] = impactedKeys.includes(key) ? e.target.checked : colvis[key];
                                                                                                    return acc;
                                                                                                }, {});

                                                                                                setColvis(updatedObj);
                                                                                            }}
                                                                                        />
                                                                                        <span>
                                                                                            < >Select All Owner Domain</>
                                                                                        </span>
                                                                                    </label>
                                                                                </li>
                                                                            </Col>
                                                                        </>
                                                                    }



                                                                    {filterRepeaterValueOptions_Od_colvis.map(({ label, value }) => (
                                                                        <Col span={8}>
                                                                            <li key={value}>
                                                                                <label htmlFor={value}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={value}
                                                                                        checked={colvis[value]}
                                                                                        onChange={() => {
                                                                                            const tempData = { ...colvis };
                                                                                            tempData[value] = !tempData[value];
                                                                                            setColvis(tempData);
                                                                                        }}
                                                                                    />
                                                                                    <span> {label?.length >= 50 ?
                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                        < >{label}</>}
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                        </Col>
                                                                    ))}
                                                                    {filterRepeaterValueOptions_Ipd_colvis.length > 0 &&
                                                                        <>
                                                                            <hr className="new_item_line_d3" />

                                                                            <Col span={24}>

                                                                                <li>
                                                                                    <label htmlFor="select_all_adcodes3">
                                                                                        <input
                                                                                            className={isIndeterminateIpd(colvis) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                                            type="checkbox"
                                                                                            id="select_all_adcodes3"
                                                                                            checked={
                                                                                                filterRepeaterValueOptions_Ipd_colvis
                                                                                                    .map(item => item.value)
                                                                                                    .every(key => colvis[key] === true)
                                                                                            }
                                                                                            onChange={(e) => {
                                                                                                const impactedKeys = filterRepeaterValueOptions_Ipd_colvis.map(item => item.value);
                                                                                                const updatedObj = Object.keys(colvis).reduce((acc, key) => {
                                                                                                    acc[key] = impactedKeys.includes(key) ? e.target.checked : colvis[key];
                                                                                                    return acc;
                                                                                                }, {});

                                                                                                setColvis(updatedObj);
                                                                                            }}
                                                                                        />
                                                                                        <span>
                                                                                            < >Select All Inventory Partner Domain</>
                                                                                        </span>
                                                                                    </label>
                                                                                </li>
                                                                            </Col>
                                                                        </>
                                                                    }


                                                                    {filterRepeaterValueOptions_Ipd_colvis.map(({ label, value }) => (
                                                                        <Col span={8}>
                                                                            <li key={value}>
                                                                                <label htmlFor={value}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={value}
                                                                                        checked={colvis[value]}
                                                                                        onChange={() => {
                                                                                            const tempData = { ...colvis };
                                                                                            tempData[value] = !tempData[value];
                                                                                            setColvis(tempData);
                                                                                        }}
                                                                                    />
                                                                                    <span> {label?.length >= 50 ?
                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                        < >{label}</>}
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                        </Col>
                                                                    ))}


                                                                </Row>

                                                            </ul>

                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            <div className="export_btn_hover_d2">

                                                {exportMediaPlannerLoading ?
                                                    <Button
                                                        className="export_btn_d2"
                                                        icon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                <g clip-path="url(#clip0_11006_24214)">
                                                                    <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_11006_24214">
                                                                        <rect width="14" height="14" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        }>
                                                        Export
                                                    </Button> :
                                                    data.length === 0 ?
                                                        <Button
                                                            icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <g clip-path="url(#clip0_11006_24214)">
                                                                        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_11006_24214">
                                                                            <rect width="14" height="14" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            }>
                                                            Export
                                                        </Button>
                                                        :
                                                        <Button
                                                            style={{ transform: "tranlateY(-0.3rem)" }}
                                                            onClick={exportMediaPlanner}
                                                            className="export_btn_d2"
                                                            icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <g clip-path="url(#clip0_11006_24214)">
                                                                        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_11006_24214">
                                                                            <rect width="14" height="14" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            }>
                                                            Export
                                                        </Button>
                                                }
                                            </div>



                                        </div>



                                    </>
                                }

                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2 user_sync_table_v2 check_adcodes_listing ctv_planner_table">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    components={{ body: { row: EditableRow, cell: EditableCell } }}
                                    rowClassName={() => 'editable-row'}
                                    bordered
                                    dataSource={data}
                                    columns={mergedColumns}
                                    pageSize={100}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    // scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }} 
                                    scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: trueKeyCountIpd(colvis) === 1 ? 'calc(100vh - 34.6rem' : 'calc(100vh - 31rem' }}
                                />


                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {pageView === "create" &&
                <CTVConfigureAdcodes
                    handlePageViewChange={handlePageViewEdit}
                />
            }


            <Modal className='custom_modal custom_modal_form_d2'
                title={
                    <div className='custom_modal--header'>
                        <div className="d_flex justify_content_between">

                            <h3 className='heading' >
                                <img src={uploadFileIcon} alt='USP' /> CSV Upload
                            </h3>
                            <div className="domain_history_button" style={{ marginRight: "2.8rem" }} >
                                <a href="/ctvCsvHistory" target="_blank">
                                    <img src={historyButton} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                }
                visible={isModalVisible}
                onCancel={closeModal}
                closable={true}
                maskClosable={false}
                width={770}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_between publisher_domain_upload_footer">
                        <div className="d_flex justify_content_start align_items_center"
                        // style={{ opacity: buttonProcessing ? "1" : "0" }}
                        >
                            {/* <img src={iconProcessingRequest} alt="" />
                                        <p >Processing request ...</p> */}
                        </div>
                        <div className="btn_group justify-content-end gap_8">
                            {buttonProcessing ?
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    >
                                        Discard
                                    </button>
                                    <button
                                        className="w_120_d2 btn btn_primary w_fit_content loader"

                                    >
                                        <span>Upload</span>

                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>
                                </> :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModal}> Discard </button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content" disabled={adcodeCount === 0} onClick={handSubmitCtvCsvUpload}>Upload</button>
                                </>
                            }
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className="tab_content--body">

                        {ctvCsvUpload?.filename === "" &&
                            <div className="form_content_block--group publisher_domain_upload">
                                <label for='file0029' className='ant_upload_drag'>
                                    <p className="upload_drag_icon">
                                        <img src={uploadIcon} alt='USP' />
                                    </p>
                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> </p>

                                    <p className="ant_upload_hint ">
                                        CSV (max. 1000 Rows)
                                    </p>
                                </label>
                                <input className='form_upload d-none' type="file" id="file0029" name="file"
                                    accept=".csv"
                                    onChange={handleFileChange}
                                />
                                <div
                                    className="publisher_domain_sample_download"
                                >
                                    <div
                                        onClick={handleDownload}
                                    >
                                        <div className="publisher_domain_download_box">
                                            <img src={downloadCsvIcon} alt="" />

                                            <p>Download CSV Template</p>
                                        </div>
                                    </div>
                                </div>

                                <span className="error_content"> {errorMsg !== null && <> {errorMsg}</>}
                                </span>
                            </div>
                        }
                        {ctvCsvUpload?.filename !== "" &&
                            <div className="ant_upload_list--item mb-0 mt-4">
                                <div className="ant_upload_list--content">
                                    {ctvCsvUpload.type !== "" ? <>
                                        {ctvCsvUpload.type === "text/plain" ?
                                            <img src={txtIcon} alt="USP" />
                                            :
                                            <img src={csvIcon} alt="USP" />

                                        }
                                    </> : <></>}

                                    <div className="ant_upload_list--info">
                                        <span className="ant_upload_list--info-name">{ctvCsvUpload.filename}</span>
                                        <span className="ant_upload_list--info-size">   {
                                            ctvCsvUpload.size !== "" ? (
                                                ctvCsvUpload.size < 1024 ? (
                                                    `${ctvCsvUpload.size} Bytes`
                                                ) : ctvCsvUpload.size < 1024 * 1024 ? (
                                                    `${(ctvCsvUpload.size / 1024).toFixed(2)} KB`
                                                ) : (
                                                    `${(ctvCsvUpload.size / (1024 * 1024)).toFixed(2)} MB`
                                                )
                                            ) :
                                                <></>}</span>
                                    </div>
                                </div>
                                <button type="link" className="ant_upload_list--delete download_icon_d2"
                                    onClick={() => {
                                        // setErrorMsgBackendData([])
                                        setCtvCsvUpload({
                                            data: "",
                                            filename: "",
                                            type: "",
                                            size: ""
                                        })
                                    }}
                                >
                                    <img src={deleteIcon} alt="USP" />
                                </button>
                            </div>
                        }

                        {/* {errorMsgBackendData.length > 0 &&
                            <>
                                <span className="error_content">Dublicate Records Found</span>
                                <span className="error_content" style={{
                                    maxHeight: "20rem",
                                    overflowY: "auto",
                                    display: "block"
                                }}>   <table border="1" cellPadding="8" cellSpacing="0"
                                    style={{ width: "100%", tableLayout: "fixed", textAlign: "left", border: "1px solid red" }}
                                >
                                        <thead>
                                            <tr>
                                                <th>Bundle</th>
                                                <th>Store</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {errorMsgBackendData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.bundle}</td>
                                                    <td>{item.store}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </span>
                            </>
                        } */}
                    </div>
                </div>
            </Modal>

        </>
    );
};

export default CTVMediaPlanner;
